import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import {
  IOrders,
  DEFAULT_ORDERS,
  IOrder,
  IParsedOrder,
  IParsedOrders,
} from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { AllOrdersGateway } from './all-orders.gateway';

@Injectable({
  providedIn: 'root',
})
export class AllOrdersStore {
  private readonly gateway: AllOrdersGateway = new AllOrdersGateway();

  #ordersResource: ResourceRef<IApiResponse<IParsedOrders> | undefined> =
    resource({
      loader: (): Promise<IApiResponse<IParsedOrders>> => {
        return firstValueFrom(this.gateway.get());
      },
    });

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#ordersResource.isLoading()
  );
  readonly orders: Signal<IParsedOrders> = computed(
    (): IParsedOrders =>
      this.#ordersResource.hasValue()
        ? (this.#ordersResource.value()?.data ?? DEFAULT_ORDERS)
        : DEFAULT_ORDERS
  );

  readonly allOrders: Signal<IParsedOrder[]> = computed(() => {
    const orders: IParsedOrders = this.orders();
    return orders.activeOrders.concat(orders.archivedOrders);
  });

  reloadOrders(): void {
    this.#ordersResource.reload();
  }
}
